



















































































































import Vue from 'vue';
import router from './router';
import { mapState } from 'vuex';
import Moment from 'moment';
import Helpers from './mixins/helpers';
import Api from './mixins/api';
import axios from 'axios';
import VueScrollTo from 'vue-scrollto';
import disclaimerData from '@/content/disclaimers.json';
import ErrorModal from '@/components/dumb/ErrorModal.vue';
import LoadingModal from '@/components/dumb/LoadingModal.vue';
import LoadingFancy from '@/components/dumb/LoadingFancy.vue';
import PrivacyModal from '@/components/dumb/PrivacyModal.vue';
import TermsModal from '@/components/dumb/TermsModal.vue';
import AcknowledgementModal from '@/components/dumb/AcknowledgementModal.vue';
import InfoModal from '@/components/dumb/InfoModal.vue';
import AlertBanner from '@/components/dumb/AlertBanner.vue';
import { IDisclaimer, IOffersItem, IStoreStateAppFinanceOptions, IVehicleApi } from './types';
import { EOfferType } from './enums';
import DisclaimersWrapper from '@/components/Disclaimers/DisclaimersWrapper.vue';
import { getPreApprovalObj, getQuoteCreateObj, getSelectionSignature, getUpdateRepaymentsObj, hasQuoteConflict, hasRepaymentConflict } from './mixins/quoteHelpers';
import { updateQuoteApi, updateRepaymentsApi } from './mixins/quoteApi';

Vue.use(VueScrollTo);

export default Vue.extend({
	name: 'App',
	components: {
		LoadingModal,
		LoadingFancy,
		ErrorModal,
		PrivacyModal,
		TermsModal,
		AcknowledgementModal,
		InfoModal,
		AlertBanner,
		// lazy: only fetched when forgerockEnabled renders them
		ForgeRockApp: () => import('@/components/ForgeRockApp.vue'),
		OtpModal: () => import('@/components/OtpModal.vue'),
		DisclaimersWrapper
	},
	data(): any {
		return {
			isSavingQuote: false,
			// a save-quote that closes a popup keeps isFinanceLoading held until the
			// route changes, so the popup's controls stay disabled until it is gone
			holdFinanceLoadingUntilRouteChange: false,
			savedQuotePath: '',
			hasDoneFirstRetrieve: false,
			// a RetrieveQuote has completed this session. Distinct from
			// retrieveQuote.success, which doubles as "show the alpha figures" and is
			// cleared by every slider / finance-type change on TprAdjust (resetAlpha)
			// while the retrieved response itself stays in the store
			hasRetrievedQuote: false,
			// the selection the saved quote is known to match lives in
			// app.alphaSelection (store) so getUseAlpha can compare against it
			// the finance product (1 access / 4 fixed rate) the quote was last
			// saved with: recorded at CreateQuote and after each successful
			// UpdateQuote. A product change must go through UpdateQuote, not just
			// UpdateRepayments, and the retrieved quote's loanType is not a
			// reliable way to see one (it is guarded as missing elsewhere), so the
			// posted value is remembered instead. 0 = unknown (fresh page load):
			// fall back to the retrieved loanType
			savedQuoteLoanType: 0,
			logoutTimeRemaining: 0,
			logoutInterval: 0,
			isDealerReady: false,
			isVehicleReady: false,
			isFinanceReady: false,
			isAlphaReady: false,
			imageSuffixes: ['003', '012', '015', '022', '033']
		};
	},
	computed: {
		...mapState({
			state(): any { return (this as any).$store.state },
			app(): any { return (this as any).$store.state.app },
			dealer(): any { return (this as any).$store.state.dealer },
			vehicle(): any { return (this as any).$store.state.vehicle },
			customer(): any { return (this as any).$store.state.customer },
			finance(): any { return (this as any).$store.state.finance },
			quoteCreate(): any { return (this as any).$store.state.quoteCreate },
			retrieveQuote(): any { return (this as any).$store.state.retrieveQuote },
			updateQuote(): any { return (this as any).$store.state.updateQuote },
			updateRepayments(): any { return (this as any).$store.state.updateRepayments },
			promoCode(): any { return (this as any).$store.state.promoCode },
			disclaimers(): any { return (this as any).$store.state.disclaimers },
			openModal(): any { return (this as any).$store.state.openModal },
			forgeRockApp(): any { return (this as any).$store.state.forgeRockApp },
		}),
		status(){
			const preStatus = this.preApproval.preApproval.preApprovalStatus;
			return preStatus || '';
		},
		preApproval(){
			return getPreApprovalObj(this.state);
		},
		routeName(){
			return this.$route.name;
		},
		accessToken(){
			return this.forgeRockApp.tokens.accessToken;
		},
		forgerockEnabled(): boolean {
			return (this as any).$store.getters.forgerockEnabled;
		},
		showDev(){
			return location.href.includes('tpr.tfa.local') || location.search.includes('showDebugUi');
		},
		handleDevAuth(){
			this.$store.commit('setForgeRockApp', {
				...this.forgeRockApp,
				tokens: {
					accessToken: "eyJ0eXAiOiJKV1QiLCJraWQiOiJwWVlhcXVteG9raUIzaWs3K21BMFNMdnFqVFU9IiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiIwMWU1NWViMy04MDVjLTRmYzgtYTBjOS1jMzEyYTBlMzUzNTAiLCJjdHMiOiJPQVVUSDJfU1RBVEVMRVNTX0dSQU5UIiwiYXV0aF9sZXZlbCI6MTAwLCJhdWRpdFRyYWNraW5nSWQiOiI5N2U4YTUxMi03ZmU2LTQxOTItOTRiMC0yMWI4ZGY1ZTNjNzgtMTYzMDYyMyIsInN1Ym5hbWUiOiIwMWU1NWViMy04MDVjLTRmYzgtYTBjOS1jMzEyYTBlMzUzNTAiLCJpc3MiOiJodHRwczovL29wZW5hbS10ZnMtYW56LXN0YWdpbmcuaWQuZm9yZ2Vyb2NrLmlvOjQ0My9hbS9vYXV0aDIvcmVhbG1zL3Jvb3QvcmVhbG1zL2JyYXZvIiwidG9rZW5OYW1lIjoiYWNjZXNzX3Rva2VuIiwidG9rZW5fdHlwZSI6IkJlYXJlciIsImF1dGhHcmFudElkIjoidThYSzktb1hWTVlXV1JMWC05QjhuMXAtemFJIiwiY2xpZW50X2lkIjoiVFBSIiwiYXVkIjoiVFBSIiwibmJmIjoxNzYxNjI0ODg5LCJncmFudF90eXBlIjoiYXV0aG9yaXphdGlvbl9jb2RlIiwic2NvcGUiOlsib3BlbmlkIl0sImF1dGhfdGltZSI6MTc2MTYyNDg4NywicmVhbG0iOiIvYnJhdm8iLCJleHAiOjE3NjE2Mjg0ODksImlhdCI6MTc2MTYyNDg4OSwiZXhwaXJlc19pbiI6MzYwMCwianRpIjoiWG1nS2dLTVJEZ3dya2NDeG9MZ2FfSE5SWVlZIiwib21uaV9ndWlkIjoiMjI2NzVhMTAtYjM4Zi00NTZhLTg5YjEtMWIyY2JhYzg3NjE1In0.MHvCONJAaHfRxBH4HozGyZjP7SRV1vvZqY6NIO-rT7v93qgDDjmbgYp7UjJLxOcWGzXjNf2nVc7jNALkF16rNlhFdI8x6MCQQeadUWMS1fjFYToHve0IZVdhaiWGw-CvZoJKr6junnAQy1EjN4ntulnCDYVJZmsUgAUIAGhR4Q7tYXczF3nCHWt1TasSQ8UxGM1Wa-OMozhz_Skhe_2PgSySZu-ZCNjxgj4h5tDHt91YEHjfR0UhfneoZMJhf0YS-ifHUeQfxHuKnw9PxpGZFcvC0n1ufb9ROXQHasXEcV-Mcekl6MaXIC1hLyjlsvKYeSuh9N5fE7oc04k46qmBzw",
					idToken: "",
					refreshToken: "",
					tokenExpiry: 0
				},
			})
		},
		handleDevDlStore(){
			const obj = JSON.stringify(this.$store.state);
			const blob = new Blob([JSON.stringify(this.$store.state)], { type: 'text/plain' });

			// 2. Create a temporary URL for the Blob
			const url = URL.createObjectURL(blob);

			// 3. Create a temporary anchor (<a>) element
			const link = document.createElement('a');
			link.style.display = 'none'; // Hide the link
			link.href = url;
			link.download = 'store'; // Set the download attribute with the desired filename

			// 4. Append the link to the DOM, trigger a click, and remove it
			document.body.appendChild(link);
			link.click();

			// 5. Clean up by revoking the object URL and removing the link
			// A slight delay is recommended for compatibility with Firefox
			setTimeout(() => {
				URL.revokeObjectURL(url);
				document.body.removeChild(link);
			}, 0);
		},
		handleDevSummary(){
			if (this.app.orderGuid){
				(this as any).$store.commit('setApp', {
					orderGuid: ""
				});
				this.$router.push({name:'TprAdjust', query: this.$route.query});
			}
			else {
				(this as any).$store.commit('setApp', {
					orderGuid: "test"
				});
				this.$router.push({name:'SummaryPage', query: this.$route.query});
			}
		},
		handleGoToStep3(){
			this.$store.commit('setApp', {
				step: 2
			})
		},
		handleGoToCheck(){
			this.$router.push({ name: 'Check', query: {...this.$route.query, redirect: this.$route.name} });
		},
		handleDevDummy(){
			const p = [0,1,2,3,4,5,6,7,8,9];
			const rp = p.reverse();
			const mp = `${rp[9]}${rp[5]}${rp[6]}${rp[5]} ${rp[7]}${rp[1]}${rp[5]} ${rp[8]}${rp[0]}${rp[2]}`;
			this.$store.commit('setCustomer', {
				"companyName":"","abn":"","title":"Mr","firstName":"kk","preferredName":"","lastName":"hh","dob":"2002-01-01","preferredDealership":"Chatswood","phone":mp,"otpPhone":"","resumePhone":"","email":"karl@t-bone.com.au","address":"123 Read St, ROCKINGHAM WA 6168","unitNo":"","streetNo":"123","streetName":"Read","streetType":"St","streetAddress":"123 Read St","suburb":"ROCKINGHAM","state":"WA","postcode":"6168","sa1Code":"5118826","subPremise":"","privacyAccepted":false,"financeLeadPostcode":"","financeLeadPrivacyAccepted":false,"privacyAcceptedFallback":false,"businessUse":false,"privacyAcceptedTpr":true,"livingStatus":"2","licenseOrigin":"Overseas","licenseNumber":"12345677","licenseState":"Overseas","otherProperty":true,"recaptcha":"","additionalComment":"","hasSubmittedLead":false,"otp":""
			});
		},
		isLoading(): boolean {
			return this.app.isLoading;
		},
		isOtpModalOpen: {
			get(): boolean {
				return (this as any).app.isOtpModalOpen;
			},
			set(v: boolean){
				(this as any).$store.commit('setAppIsOtpModalOpen', v);
			}
		},
		flow(): string {
			return (this as any).$store.getters.flow;
		},
		isBusiness(){
			return this.flow == 'business';
		},
		isTokenExpired(): boolean {
			return (this as any).$store.state.forgeRockApp.isTokenExpired;
		},
		// the on-load RetrieveQuote only runs off the checkout (Summary / TprAdjust
		// visits); the checkout flows retrieve at their own point, see canRetrieveOnLoad
		canRetrieve(): boolean {
			return (this as any).$store.getters.canRetrieveOnLoad;
		},
		isReady(): boolean {
			return (this.isDealerReady && this.isVehicleReady && this.isFinanceReady) || 'RedirectPage' == this.$route.name || (this.forgerockEnabled && 'Check' == this.$route.name);
		},
		alertMessage(): string {
			return ``;// `Due to the unprecedented global demand, we are currently experiencing extended wait times which vary across our model range. This may result in a different specification and/or different price point at <strong>time of delivery</strong>. More information is available <a href="https://www.toyota.com.au/support/delivery-wait-times-availability" target="_blank">here</a>. Please contact us for the latest update. `; //this.vehicle.model.toUpperCase().includes('RAV4') ?
		},
		isVehicleCampaign(){
			return this.finance.internalFinanceType == 'Campaign';
		},
	},
	watch: {
		'routeName'(v){
			this.$store.commit('setAppUseCurrentRouteName', v);
			// the per-route save guard only protects against re-entry during one
			// visit; a fresh visit to the same url (e.g. back into TprAdjust after
			// adjusting sliders) must be allowed to save again
			this.savedQuotePath = '';
			// the saved-quote view must not leak into an edit session
			if (v == 'TprAdjust' && this.app.viewCurrentQuote){
				this.$store.commit('setAppViewCurrentQuote', false);
			}
			if (this.holdFinanceLoadingUntilRouteChange){
				this.holdFinanceLoadingUntilRouteChange = false;
				this.$store.commit('setApp', { isFinanceLoading: false });
			}
		},
		'app.tprFormSubmitted'(v){
			if (v){
				this.doTprSubmittedFlow().catch((e: any) => {
					console.log('doTprSubmittedFlow error', e);
				});
			}
		},
		'accessToken'(v){
			if (v && this.isFinanceReady && this.canRetrieve){
				(this as any).doFirstRetrieve();
			}
		},
		'isFinanceReady'(v){
			if (v && this.canRetrieve && (this.accessToken || !Helpers.getCookie('omniguid'))){
				(this as any).doFirstRetrieve();
			}
		},
		// the gate opens later than the data: retry when the route changes
		'canRetrieve'(v){
			if (v && this.isFinanceReady && (this.accessToken || !Helpers.getCookie('omniguid'))){
				(this as any).doFirstRetrieve();
			}
		},
		'isReady'(v): void {
			(this as any).$store.dispatch('setLoading', !v);
		},
		'isTokenExpired'(v: boolean): void {
			this.handleExpiredToken(v, this.$route.name, this.app.step);
		},
		'app.step'(v: number): void {
			// final checkout step: sync the saved quote with the customer's
			// selections (replaces the old quantum step-3 QuoteUpdate)
			const s = (this as any).$store.state;
			if (v == 3 && s.quoteCreate.pegaCaseTracking && s.forgeRockApp.tokens.accessToken){
				this.handleSaveQuote();
			}
			this.handleExpiredToken(this.isTokenExpired, this.$route.name, v);
		},
		// isTokenExpired only fires on its false->true transition, so a token
		// that expired while the business gate held it back would otherwise
		// never re-trigger the OTP flow. Re-check on retail re-entry only —
		// retail-to-retail flow changes must not reopen a modal the user closed
		'flow'(v: string, oldV: string): void {
			const wasBusiness = 'business' == oldV || 'business-campaign' == oldV;
			if (wasBusiness && !this.$store.getters.isBusinessFlow){
				this.handleExpiredToken(this.isTokenExpired, this.$route.name, this.app.step);
			}
		}
	},
	methods: {
		handleExpiredToken(isExpired: boolean, routeName: string, stepNumber: number){
			// ForgeRock off: no Check route exists and the OTP modal must never
			// open (this covers the isTokenExpired / app.step / flow watchers)
			if (!this.forgerockEnabled) return;
			// business flows have no ForgeRock session to re-verify, so never
			// interrupt them with the Check redirect / OTP modal (the expiry
			// timer can still fire if the user acquired tokens in a retail flow
			// before switching)
			if (this.$store.getters.isBusinessFlow) return;
			if (isExpired && Helpers.canOpenOtpModal(routeName, stepNumber)){
				this.$nextTick(() => {
					if (this.$route.name != 'Check'){
						this.$router.push({ name: 'Check', query: {...this.$route.query, redirect: this.$route.name} });
					}
					(this as any).isOtpModalOpen = true;
				});
			}
		},
		async doTprSubmittedFlow(){
			try {
				// CreateQuote (TprForm) has just posted finance.financeType; record
				// it before getFinance re-reads the finance options
				this.rememberSavedQuoteLoanType(this.finance.financeType || this.app.financeType || 0);
				const financeSuccess = await this.getFinance(this.vehicle);
				console.log('doTprSubmittedFlow', financeSuccess);
				if (financeSuccess){
					const success = await this.doUpdateRepayments();
					if (success){
						// create-quote flow: retrieve straight after CreateQuote +
						// UpdateRepayments (tpr parity) so the saved quote is checked
						// against the loaded vehicle/finance before TprAdjust shows it
						this.hasDoneFirstRetrieve = true;
						await this.doRetrieveAndCheckConflicts();
						this.isAlphaReady = true;
						console.log('bfrp 8');
						await this.$router.push({ name: 'TprAdjust', query: this.$route.query });
					}
				}
			}
			finally {
				if (this.openModal.id == 'LoadingFancyModal'){
					this.$store.commit('resetOpenModal');
				}
				this.$store.commit('setIsPostingTpr', false);
			}
		},
		async doUpdateQuote(useLoader = true){
			let success = false;
			if (useLoader){
				this.$store.commit('setApp', { isFinanceLoading: true });
			}
			const obj = getQuoteCreateObj(this.state, false);
			const res = await updateQuoteApi(obj);
			console.log('res1',res);
			if (res && res.success){
				success = true;
				this.$store.commit('setUpdateQuote', res);
				// the quote now carries the posted product
				this.rememberSavedQuoteLoanType(this.finance.financeType || this.app.financeType || 0);
			}
			else {
				console.log('update quote failed');
			}
			if (useLoader){
				this.$store.commit('setApp', { isFinanceLoading: false });
			}
			console.log('doUpdateQuote',success);
			return success;
		},
		async doUpdateRepayments(useLoader: boolean){
			// do updateRepayments and show alpha
			let success = false;
			if (useLoader){
				this.$store.commit('setApp', { isFinanceLoading: true });
			}
			const obj = getUpdateRepaymentsObj(this.state, this.$route);
			const res = await updateRepaymentsApi(obj);
			if (res && res.success){
				this.$store.commit('setUpdateRepayments', res);
				success = true;
			}
			if (useLoader){
				this.$store.commit('setApp', { isFinanceLoading: false });
			}
			return success;
		},
		async doCheckForConflicts(args: any){
			let isAllSuccess = false;
			this.$store.commit('setApp', { isFinanceLoading: true });
			try {
				if (this.app.alphaSelection && this.app.alphaSelection === getSelectionSignature(this.state)){
					console.log('quote already matches the current selection, skipping update');
					isAllSuccess = true;
					return isAllSuccess;
				}
				// the return flow's first retrieve happens here (Continue from
				// 03 Payment into 04 Summary, or Apply on TprAdjust), so the status
				// and conflict checks below compare against the saved quote rather
				// than the blank one. A retrieve that already completed (create-quote
				// flow, on-load) is not repeated: nothing has changed the saved
				// quote since, and its response is still in the store
				let isRetrieveSuccess = this.hasRetrievedQuote || this.retrieveQuote.success;
				if (!isRetrieveSuccess){
					isRetrieveSuccess = await this.$store.dispatch('doRetrieveQuote');
					this.hasRetrievedQuote = isRetrieveSuccess;
				}
				if (!isRetrieveSuccess){
					console.log('handleFailedRetrieveOrQuote bf 3');
					this.handleFailedRetrieveOrQuote();
					return false;
				}
				const hasCompatibleStatus = Helpers.isQuoteAbleToSave(this.state);
				console.log('hasCompatibleStatus',hasCompatibleStatus,this.status);
				if (!hasCompatibleStatus){
					console.log('will not update quote / repayments due to status.');
					this.handleFailedRetrieveOrQuote();
					return false;
				}
				// a finance product change is a quote conflict (UpdateQuote, then
				// UpdateRepayments); compare the selected product with the one the
				// quote was saved with, see savedQuoteLoanType
				const savedLoanType = this.savedQuoteLoanType || this.retrieveQuote.response.loanType || 0;
				const isProductChanged = !!savedLoanType && this.app.financeType != savedLoanType;
				const isConflictedQuotes = !!hasQuoteConflict(this.state) || isProductChanged;
				const isConflictedRepayments = !!hasRepaymentConflict(this.state);
				console.log('doCheckForConflicts',isConflictedQuotes,isConflictedRepayments,'product',this.app.financeType,'saved',savedLoanType,'retrieved',this.retrieveQuote.response.loanType);
				if (isConflictedQuotes){
					const success = await this.doUpdateQuote(false);
					if (success){
						const success2 = await this.doUpdateRepayments();
						if (!success2){
							console.log('handleFailedRetrieveOrQuote if bf 1')
							this.handleFailedRetrieveOrQuote();
						}
						else {
							isAllSuccess = true;
						}
					}
					else {
						console.log('handleFailedRetrieveOrQuote else bf 1')
						this.handleFailedRetrieveOrQuote();
					}
				}
				else if (isConflictedRepayments){
					const success2 = await this.doUpdateRepayments();
					if (!success2){
						console.log('handleFailedRetrieveOrQuote if bf 2')
						this.handleFailedRetrieveOrQuote();
					}
					else {
						isAllSuccess = true;
					}
				}
				else {
					// nothing to save: the retrieved quote already matches
					isAllSuccess = true;
				}
				if (isAllSuccess){
					this.$store.commit('setApp', { alphaSelection: getSelectionSignature(this.state) });
				}
			}
			catch (e){
				console.log('handleSaveQuote error', e);
				this.handleFailedRetrieveOrQuote();
			}
			finally {
				this.isSavingQuote = false;
				// the callback (navigation) runs whatever the outcome, matching the
				// early-out paths in shouldSaveQuoteRepayments
				if (args && args.callback){
					Vue.nextTick(() => {
						args.callback();
					});
					// the callback navigates away; release the loader in the routeName watcher
					this.holdFinanceLoadingUntilRouteChange = true;
				}
				else {
					this.$store.commit('setApp', { isFinanceLoading: false });
				}
			}
			return isAllSuccess;
		},
		shouldSaveQuoteRepayments(args: any){
			if (this.isSavingQuote){
				console.log('saveQuote already in progress, skipping');
				return false;
			}
			// UpdateQuote/UpdateRepayments need a live verified session; with an
			// expired or missing token they can only fail, so don't start them
			const fr = (this as any).$store.state.forgeRockApp;
			if (fr.isTokenExpired || !fr.tokens.accessToken){
				console.log('no verified session, skipping save');
				if (args && args.callback){
					Vue.nextTick(() => {
						args.callback();
					});
				}
				return false;
			}
			// return flow (a stored case, no CreateQuote this session): the saved
			// quote is synced once, on Continue from 03 Payment into 04 Summary
			// (app.step watcher). TprAdjust's Continue only navigates. The create
			// flow keeps saving from TprAdjust so the adjusted quote is in place
			// before the checkout
			if (this.$route.name == 'TprAdjust' && !this.app.tprFormSubmitted){
				console.log('return flow: deferring save to 03 Payment Continue');
				if (args && args.callback){
					Vue.nextTick(() => {
						args.callback();
					});
				}
				return false;
			}
			// the pre-approval status check lives in doCheckForConflicts: it needs
			// the retrieved quote, which the return flow only fetches there
			const savePath = this.$route.fullPath;
			if (this.savedQuotePath === savePath){
				console.log('saveQuote already done for this route, skipping');
				if (args && args.callback){
					Vue.nextTick(() => {
						args.callback();
					});
				}
				return false;
			}
			return true;
		},
		handleSaveQuote(args: any): void {
			// commit('setApp', { isFinanceLoading: false });
			if (!this.shouldSaveQuoteRepayments(args)){
				console.log('handleSaveQuote skipped');
				return;
			}
			this.isSavingQuote = true;
			this.savedQuotePath = this.$route.fullPath;
			this.doCheckForConflicts(args);
		},
		handleRetrieveQuote(): void {
			this.$store.dispatch('doRetrieveQuote');
		},
		// see savedQuoteLoanType; the cookie carries it across a page reload
		rememberSavedQuoteLoanType(loanType: number): void {
			this.savedQuoteLoanType = loanType || 0;
			Helpers.setTprLoanTypeCookie(this.quoteCreate.pegaCaseTracking, this.quoteCreate.validityDate, this.savedQuoteLoanType);
		},
		handleOtpCloseClick(): void {
			(this as any).isOtpModalOpen = false;
		},
		handleFailedRetrieveOrQuote(){
			console.log('handleFailedRetrieveOrQuote');
			this.$store.commit('setApp', { alphaSelection: '' });
			this.$store.commit('setUpdateQuote', {
				...this.updateQuote,
				success: false
			});
			this.$store.commit('setUpdateRepayments', {
				...this.updateRepayments,
				success: false
			});
			this.$store.commit('setAppUseEstimateInsteadOfAlpha', true);
		},
		// RetrieveQuote, then compare the saved quote with the loaded
		// vehicle/finance; a failed retrieve or a mismatch falls back to the estimate
		async doRetrieveAndCheckConflicts(): Promise<boolean> {
			const success = await this.$store.dispatch('doRetrieveQuote');
			this.hasRetrievedQuote = success;
			if (!success){
				console.log('failed retrieve. setting to use estimate.');
				this.handleFailedRetrieveOrQuote();
				return false;
			}
			const isConflictedQuotes = hasQuoteConflict(this.state);
			const isConflictedRepayments = hasRepaymentConflict(this.state);
			if (isConflictedQuotes || isConflictedRepayments){
				console.log('conflicting quote/repayments. setting to use estimate.');
				this.handleFailedRetrieveOrQuote();
				return false;
			}
			// the saved quote matches what is loaded: no save needed until the
			// selection changes
			this.$store.commit('setApp', { alphaSelection: getSelectionSignature(this.state) });
			return true;
		},
		// on-load retrieve for the non-checkout routes (see canRetrieve)
		async doFirstRetrieve(){
			if (this.hasDoneFirstRetrieve) return;
			// nothing to retrieve yet: leave the flag clear so a later token / case
			// (create-quote flow) still gets its first retrieve
			if (!this.accessToken || !this.quoteCreate.pegaCaseTracking){
				this.isAlphaReady = true;
				return;
			}
			this.hasDoneFirstRetrieve = true;
			await this.doRetrieveAndCheckConflicts();
			this.isAlphaReady = true;
		},

		setEnquirySourceCookie(source: string): void {
			document.cookie = `ipadutm=${(source)};expires=Thu, 01 Jan 2070 00:00:00 GMT`;
		},
		getEnquirySources(source: string): void {
			const url = Api.returnEnquirySourceUrl((window as any).StoreWebsiteInfo.DealerID);
			Helpers.clog(url);
			axios.get(url).then((response) => {
				Helpers.clog(response);
				if (response.data && response.data.length) {
					const s = response.data.filter((o: any) => o.Source == source);
					if (s.length) {
						(this as any).$store.commit('setApp', {
							enquirySource: {
								id: s[0].UtmID,
								suburb: s[0].Suburb,
								value: source
							}
						});
						this.setEnquirySourceCookie(source);
					}
					else {
						Helpers.clog('no match found for UTM');
					}
				}
			}).catch((response) => {
				console.log('Error receiving UTMs');
				console.log(response);
			})
		},
		checkGuid(): void {
			const url = Api.returnGuidCheckUrl(this.quoteCreate.guestRateIdentifier);
			axios.get(url).then((response: any) => {
				Helpers.clog(response);
				const rExpiry = new Date(response);
				const gExpiry = new Date(this.quoteCreate.validityDate);
				const rex = {
					day: rExpiry.getDate(),
					month: rExpiry.getMonth(),
					year: rExpiry.getFullYear()
				};
				const gex = {
					day: gExpiry.getDate(),
					month: gExpiry.getMonth(),
					year: gExpiry.getFullYear()
				};
				const isValid = (rex.year <= gex.year) && (rex.month <= gex.month) && (rex.day <= gex.day);
				console.log('is guid valid', isValid);
				if (!isValid) {
					const pegacaseCookie = Helpers.getCookie('tprcaseid') || '';
					const tprguidCookie = Helpers.getCookie('tprguid') || '';
					Helpers.clog('deleting cookies (chrome sucks on localhost)');
					document.cookie = 'tprguid=' + tprguidCookie + ';expires=' + ";expires=Thu, 01 Jan 1970 00:00:00 GMT";
					document.cookie = 'tprcaseid=' + pegacaseCookie + ';expires=' + ";expires=Thu, 01 Jan 1970 00:00:00 GMT";
					(this as any).$store.commit('setQuoteCreate', JSON.parse(JSON.stringify(Helpers.blankQuoteCreate)));
					(this as any).$store.commit('setTpr', {
						detailIdentifier: ''
					});
				}
				this.isFinanceReady = true;
			}).catch((response) => {
				Helpers.clog(response);
				this.isFinanceReady = true;
			});
		},
		commitAppFinanceOptions(): void {
			const vehicleData = this.vehicle;
			const cookieVals: string = Helpers.getCookie("financeoptions") || this.$route.query.financeOptions?.toString() || '';
			const cookieValsArr = cookieVals.split("_");
			if (cookieValsArr.length == 3){
				cookieValsArr.push("1");
			}
			const isCookieRightFinanceType = vehicleData.availableFinanceSetting.filter((o: any) => o.TypeOfFinance == parseInt(cookieValsArr[3])).length;
			const cookieFt = parseInt(cookieValsArr[3]);
			const cookieValsObj: IStoreStateAppFinanceOptions = {
				financeDeposit: parseInt(cookieValsArr[0]),
				termsInYears: parseInt(cookieValsArr[1]),
				kms: cookieFt == 4 ? 0 : parseInt(cookieValsArr[2]),
				balloonPercentage: cookieFt == 4 ? parseInt(cookieValsArr[2]) : 0,
				financeType: cookieFt || 1
			};
			const isCookieValsValid = cookieValsObj.kms && (cookieValsObj.financeType == 4 || cookieValsObj.kms);
			const useCookie = isCookieValsValid && isCookieRightFinanceType;

			const fallbackObj: IStoreStateAppFinanceOptions = {
				financeDeposit: vehicleData.initialFinanceSetting.DepositRequired,
				termsInYears: vehicleData.initialFinanceSetting.TermInYears,
				kms: vehicleData.initialFinanceSetting.KmsPerYear,
				balloonPercentage: vehicleData.initialFinanceSetting.BalloonPercentage,
				financeType: vehicleData.initialFinanceSetting.TypeOfFinance
			};
			const finalObj0: IStoreStateAppFinanceOptions = useCookie ? cookieValsObj : fallbackObj;
			const forceFallbackArr = finalObj0.financeType == 4 && !this.app.enableFixedRate;
			const finalObj = forceFallbackArr ? fallbackObj : finalObj0;
			this.$store.commit('setAppFinanceOptions', finalObj);
		},
		setOriginalFinanceType(){
			this.$store.commit('setAppOriginalFinanceType', Helpers.getFinanceTypeFromCookie(1));
		},
		async getFinance(vehicleData: any): Promise<boolean> {
			const sliders = Helpers.getCookie("financeoptions");
			const financeOptions = sliders ? sliders.split("_") : [
				vehicleData.initialFinanceSetting.DepositRequired || this.app.financeDeposit,
				vehicleData.initialFinanceSetting.TermInYears,
				vehicleData.initialFinanceSetting.KmsPerYear,
				vehicleData.initialFinanceSetting.TypeOfFinance,
			];
			if (financeOptions.length == 3){
				financeOptions.push(1);
			}

			const financeType = parseInt(this.$route.query.ft || financeOptions[3]);
			const termsInYears = parseInt(this.$route.query.t || financeOptions[1]);
			const kms = financeType != 4 ? parseInt(this.$route.query.k || financeOptions[2]) : 0;
			const bp = financeType == 4 ? parseInt(this.$route.query.bp || financeOptions[2]) : 0;
			let financeDeposit = parseInt(this.$route.query.f || financeOptions[0]);
			if (!isNaN(financeDeposit)) {
				financeDeposit = Math.min(financeDeposit, vehicleData.maximumDeposit);
				// financeDeposit = Math.max(financeDeposit, this.dealer.depositMinimum);
			}
			financeDeposit = !isNaN(financeDeposit) ? financeDeposit : 100;

			this.$store.commit('setAppFinanceType', financeType);
			this.$store.commit('setAppLoanTerm', !isNaN(termsInYears) ? termsInYears : 0);
			this.$store.commit('setAppKmsPerYear', !isNaN(kms) ? kms : 0);
			this.$store.commit('setAppFinanceDeposit', financeDeposit);
			this.$store.commit('setAppBalloonPercentage', !isNaN(bp) ? bp : 0);

			return await Api.getUpdatedfinance(this, (financeData: any) => {
				if (financeData.rateExpiry) {
					(this as any).$store.commit('setQuoteCreate', {
						...this.quoteCreate,
						validityDate: financeData.rateExpiry
					});
				}
				const isBadDate = -1 != this.finance.rateExpiry.indexOf("0001-");
				const isIndicative = financeData.internalFinanceType === 'Indicative';

				(this as any).$store.commit('setApp', {
					financeDeposit: financeData.financeDeposit
				});
				if (this.quoteCreate.guestRateIdentifier && isIndicative && !this.finance.isTpr && isBadDate) {
					this.checkGuid();
				}
				else {
					this.isFinanceReady = true;
				}
			}, () => {
				this.isFinanceReady = true;
			});
		},
		getVehicleImages(): void {
			const url = Api.getVehicleImagesURL(this.vehicle.materialCode, this.vehicle.produced);
			if (!url) {
				console.log('bad url img');
				(this as any).$store.commit('setError', {
					message: `Sorry, your vehicle could not be loaded.`,
					buttons: [{
						title: 'Go back',
						callback: () => {
							location = this.app.webkiosk ? this.app.webkioskurl : this.dealer.nviUrl
						}
					}]
				});
				this.isVehicleReady = true;
				return;
			}
			Helpers.clog(url);
			axios.get(url).then((response) => {
				Helpers.clog(response);
				if (response.statusText == "OK") {
					const images360: Array<any> = response.data.Path_360;
					const imagesHero: any = {};
					let img = '';
					for (let i = 0; i != response.data.Path_Hero.length; ++i) {
						const s = response.data.Path_Hero[i].Sizes[response.data.Path_Hero[i].Sizes.length - 2];
						const s2 = response.data.Path_Hero[i].Sizes[response.data.Path_Hero[i].Sizes.length - 1];
						const imageUrl = `${response.data.Path_Hero[i].Path}/jpg/lo/${s}/${response.data.Path_Hero[i].Prefix}.jpg`;
						switch (response.data.Path_Hero[i].heroDesc) {
							case "SPR":
								imagesHero.side = imageUrl;
								img = imageUrl.replace(/jpg/g, 'png').replace(s, s2);
								break;
							case "FL34":
								imagesHero.left = imageUrl;
								break;
							case "RR34":
								imagesHero.back = imageUrl;
								break;
							case "FR34":
								imagesHero.right = imageUrl;
								break;
						}
					}
					const vehicleData: any = {
						image: img,
						images360: images360,
						imagesHero: imagesHero
					};
					(this as any).$store.commit('setVehicle', vehicleData);
				}
				else {
					console.log('not ok status');
					(this as any).$store.commit('setError', {
						message: `Sorry, your vehicle could not be loaded.`,
						buttons: [{
							title: 'Go back',
							callback: () => {
								location = this.app.webkiosk ? this.app.webkioskurl : this.dealer.nviUrl
							}
						}]
					});
				}
				this.isVehicleReady = true;
			}).catch((response) => {
				console.log('catch');
				Helpers.clog(response);
				(this as any).$store.commit('setError', {
					message: `Sorry, your vehicle could not be loaded.`,
					buttons: [{
						title: 'Go back',
						callback: () => {
							location = this.app.webkiosk ? this.app.webkioskurl : this.dealer.nviUrl
						}
					}]
				});
				this.isVehicleReady = true;
			});
		},
		getVehicle(): void {
			const materialCode = this.$route.query.m ? this.$route.query.m.toString() : '';
			const vehicleSpecificationID = this.$route.query.v ? this.$route.query.v.toString() : '';
			const batchNumber = this.$route.query.b ? this.$route.query.b.toString() : '';
			// const queryDealerID = (window as any).StoreWebsiteInfo.StockDealerID === 0 ? (window as any).StoreWebsiteInfo.DealerID : (window as any).StoreWebsiteInfo.StockDealerID;
			const url = Api.getVehicleURL(materialCode, vehicleSpecificationID, batchNumber, this.dealer.queryDealerID);
			console.log('getVehicle', url);
			if (url) {
				Helpers.clog(url);
				axios.get(url).then((response) => {
					Helpers.clog(url);
					Helpers.clog(response);
					// make sure price is not silly
					if (parseFloat(response.data.Price) < 10000) {
						console.log('bad price');
						(this as any).$store.commit('setError', {
							message: `Sorry, your vehicle could not be loaded.`,
							buttons: [{
								title: 'Go back',
								callback: () => {
									location = this.app.webkiosk ? this.app.webkioskurl : this.dealer.nviUrl
								}
							}]
						});
						this.isVehicleReady = true;
					}
					else {
						const availableFinanceTypes = ['finance'];
						const preferredFinanceType = Helpers.getCookie('selectedFinanceType') || '';
						const defaultFinanceType = 'finance';
						const initialFinanceType = preferredFinanceType && availableFinanceTypes.includes(preferredFinanceType) ? preferredFinanceType : defaultFinanceType;
						const selected = initialFinanceType || 'finance';
						(this as any).$store.commit('setApp', {
							paymentMethod: selected
						});

						// make nice car name
						const modelRegExp = new RegExp(response.data.Model, 'i');
						const transmissionRegExp = new RegExp(response.data.TransmissionType, 'i');
						const strippedFullDescription = response.data.FullDescription.replace(modelRegExp, '').replace(transmissionRegExp, '').trim();

						let specialExtraInfo = response.data.SpecialItem ? response.data.SpecialItem.SpecialExtraInfo : '';
						if (response.data.SpecialItem && !specialExtraInfo && response.data.SpecialItem.SpecialExtra && response.data.SpecialItem.SpecialExtra.length) {
							specialExtraInfo = response.data.SpecialItem.SpecialExtra[0];
						}

						// make vehicle data object
						const vehicleData: any = {
							vehicleType: response.data.VehicleType,
							materialCode: materialCode,
							vehicleSpecificationID: parseFloat(vehicleSpecificationID) || (parseFloat(response.data.VehicleSpecificationID) || 0),
							variantCode: response.data.VariantCode,
							batchNumber: batchNumber,
							vin: response.data.Vin || '',
							type: batchNumber ? 'In Stock' : 'New Virtual',
							model: response.data.Model,
							grade: response.data.Grade,
							gradeLevelDescription: response.data.GradeLevelDescription,
							price: response.data.Price,
							transmission: response.data.TransmissionType,
							fuel: response.data.Fuel,
							bodyColour: response.data.PaintName,
							interiorColour: response.data.TrimName,
							inclOption: response.data.FactoryOptionDescription,
							canBeFinanced: false,//response.data.CanBeFinanced,
							financeFailureReason: response.data.FinanceFailureReason,
							termOffset: response.data.TermOffset,
							fullDescription: response.data.FullDescription,
							strippedFullDescription: strippedFullDescription,
							gfv: response.data.GFV,
							hasNationalSpecial: response.data.HasNationalSpecial,

							specialItem: response.data.SpecialItem,
							specialExtraInfo: specialExtraInfo,
							specialUniqueName: response.data.HasNationalSpecial && response.data.SpecialItem ? response.data.SpecialItem.SpecialUniqueName : '',

							initialFinanceSetting: {}, //response.data.InitialFinanceSetting,
							availableFinanceSetting: [], //response.data.AvailableFinanceSetting,
							maximumDeposit: response.data.MaximumDeposit,
							paintName: response.data.PaintName,
							trimName: response.data.TrimName,
							produced: response.data.Produced ? response.data.Produced : '',
							backLink: response.data.BackLink,
							backLinkListing: response.data.BackLinkListing,
							offers: response.data.Offers || [],
							disableDisclaimer: !response.data.PricingMessage
						}
						if (response.data.Offers.length) {
							response.data.Offers.forEach((o: IOffersItem) => {
								o.disclaimers.forEach((d: IDisclaimer, i: number) => {
									const ft = (d.Type as any) == EOfferType.FinanceText ? 'finance' : 'driveaway';
									(this as any).$store.commit('addDisclaimer', {
										type: `specialOffer`,
										for: `specialOffer-${ft}-${i}`,
										key: `[${d.Key}]`,
										text: d.Value
									});
								});
							});
						}
						if (response.data.SpecialItem) {
							const driveawayDisclaimerArray = response.data.SpecialItem.Disclaimers;
							if (driveawayDisclaimerArray.length > 0) {
								vehicleData.disclaimer = driveawayDisclaimerArray[0].Value;
								vehicleData.disclaimerKey = driveawayDisclaimerArray[0].Key;
								Helpers.clog('Removing default standardDriveaway disclaimer and adding driveaway (specialItem)');
								(this as any).$store.dispatch('removeDisclaimer', "standardDriveaway");
								(this as any).$store.commit('addDisclaimer', {
									type: "driveaway",
									for: 'vehicle',
									key: driveawayDisclaimerArray[0].Key,
									text: driveawayDisclaimerArray[0].Value
								});
							}
							if (response.data.SpecialItem.Disclaimers.length > 1) {
								const extraVehicleDisclaimersArray = response.data.SpecialItem.Disclaimers.filter((v: any) => v['Type'] !== 'Driveaway')
								if (extraVehicleDisclaimersArray.length > 0) {
									for (const i in extraVehicleDisclaimersArray) {
										(this as any).$store.commit('addDisclaimer', {
											type: driveawayDisclaimerArray[0].Type,
											for: 'vehicle',
											key: driveawayDisclaimerArray[0].Key,
											text: driveawayDisclaimerArray[0].Value
										});
									}
								}
							}
						}
						else {
							const standardDriveaway = disclaimerData.disclaimers.filter(d => d.type == "standardDriveaway");
							if (standardDriveaway.length) {
								vehicleData.disclaimer = standardDriveaway[0].text;
								vehicleData.disclaimerKey = standardDriveaway[0].key;
								Helpers.clog('Removing default standardDriveaway disclaimer and adding standardDriveaway');
								(this as any).$store.dispatch('removeDisclaimer', "standardDriveaway");
								(this as any).$store.commit('addDisclaimer', {
									type: "standardDriveaway",
									for: 'vehicle',
									key: standardDriveaway[0].key,
									text: standardDriveaway[0].text
								});
							}
						}
						(this as any).$store.commit('setVehicle', vehicleData);

						if (vehicleData.canBeFinanced && parseFloat(vehicleData.gfv) > 1) {
							(this as any).$store.commit('setApp', {
								isFinanceAvailable: true
							});
							this.commitAppFinanceOptions();
							this.getFinance(vehicleData);
						}
						else {
							(this as any).$store.commit('setApp', {
								isFinanceAvailable: false,
								paymentMethod: 'cash'
							});
							this.isFinanceReady = true;
						}
						(this as any).$store.commit('setApp', {
							changeCarUrl: vehicleData.backLink
						});
						if (!this.app.referrer) {
							(this as any).$store.commit('setApp', { referrer: response.data.BackLinkListing });
						}
						const changeCarUrl = Api.getChangeCarURL(this.dealer.dealerID, vehicleData.variantCode, vehicleData.vehicleSpecificationID);
						Helpers.clog(changeCarUrl);
						axios.get(changeCarUrl).then((response) => {
							Helpers.clog(response);
							if (response.data.DealerExists && response.data.VehicleExists) {
								const i = response.data.Url.indexOf("/", 9);
								const url = response.data.Url.substring(i);
								(this as any).$store.commit('setApp', {
									changeCarUrl: url
								});
							}
						}).catch((error) => {
							Helpers.clog(error)
						});
						this.getVehicleImages();
					}
				}).catch((response) => {
					console.log('catch2');
					Helpers.clog(response);
					(this as any).$store.commit('setError', {
						message: `Sorry, your vehicle could not be loaded`,
						buttons: [{
							title: 'Go back',
							callback: () => {
								location = this.app.webkiosk ? this.app.webkioskurl : this.dealer.nviUrl
							}
						}]
					});
					this.isVehicleReady = true;
				});
			}
			else {
				console.log('bad url', url);
				(this as any).$store.commit('setError', {
					message: `Sorry, your vehicle could not be loaded.`,
					buttons: [{
						title: 'Go back',
						callback: () => {
							location = this.app.webkiosk ? this.app.webkioskurl : this.dealer.nviUrl
						}
					}]
				});
			}
		},
		getUserInfo(): any {
			const key = this.$route.query.d || this.$route.query.di;
			const guest = this.quoteCreate.guestRateIdentifier;
			const auth = this.$route.query.m;
			if (key && auth && guest) {
				const url = Api.getUserInfoUrl(guest, auth, key);
				axios.get(url).then((response) => {
					Helpers.clog(url);
					Helpers.clog(response);
					(this as any).$store.commit('setCustomer', Api.getUserInfoResponse(response.data));
				})
					.catch((response) => {
						Helpers.clog(response);
					})
			}
		},
		getDealer(): any {
			const dealer = (window as any).StoreWebsiteInfo;
			const queryDealerID = dealer.StockDealerID === 0 ? dealer.DealerID : dealer.StockDealerID;
			const storeUrl = 'https://' + (window as any).StoreWebsiteInfo.StoreUrl + '.dealer.toyota.com.au';

			(this as any).$store.commit('setDealer', {
				dealerName: dealer.DealerName,
				locationName: dealer.LocationName,
				dealerID: dealer.DealerID,
				stockDealerID: dealer.StockDealerID,
				queryDealerID,
				nviUrl: storeUrl,
				depositMinimum: dealer.DepositAmount || 100,
				depositAmount: dealer.DepositAmount || 100
			});
			(this as any).$store.commit('setApp', {
				financePayToday: dealer.DepositAmount || 100,
				cashDeposit: dealer.DepositAmount || 100,
				cashDepositBackup: dealer.DepositAmount || 100,
			});
			this.getAgent();
			this.getDealerInfo();
			// this.commitVehiclesAvailable(dealer.DealerID);
		},
		getDealerInfo(): void {
			const url = Api.getDealerInfoURL((window as any).StoreWebsiteInfo.DealerID);
			if (url) {
				axios.get(url).then((response: any) => {
					Helpers.clog(url);
					Helpers.clog(response);
					this.commitOpeningHours(response.data.HourInfo);
					const closedDays = response.data.HourInfo
						.filter(function (day: any) { return day.IsClosed })
						.map(function (day: any) { return day.Day });
					this.commitDateList(closedDays);
					const dealerSitesArray = response.data.DealerSites.filter((i: any) => {
						return i.LocationType == 'Branch' || i.LocationType == 'Principal'
					});
					if (dealerSitesArray.length) {
						(this as any).$store.commit('setDealer', {
							dealerSites: dealerSitesArray,
							lmct: dealerSitesArray[0].DealerLicenceNumber,
							region: dealerSitesArray[0].Region,
							primaryDealerCode: response.data.PrimaryDealerCode,
							state: dealerSitesArray[0].State,
							dealerMetroRural: dealerSitesArray[0].IsMetro,
							branchCode: dealerSitesArray[0].BranchCode,
							privacyPolicy: response.data.PrivacyPolicy,
							website: 'http://' + response.data.BaseUrl
						});
						this.getVehicle();
					}
					else {
						(this as any).$store.commit('setError', {
							message: `Sorry, your dealer agent could not be loaded.`
						});
					}
					this.isDealerReady = true;
				}).catch((response) => {
					Helpers.clog(response);
					(this as any).$store.commit('setError', {
						message: `Sorry, your dealer agent could not be loaded.`
					});
					this.isDealerReady = true;
				});
			}
		},
		getAgent(): void {
			const dealerID: number = (window as any).StoreWebsiteInfo.DealerID;
			const url: string = Api.getDealerAgentURL(dealerID);
			if (url) {
				axios.get(url).then((response) => {
					Helpers.clog(url);
					Helpers.clog(response);
					(this as any).$store.commit('setDealer', {
						storeWhyBuy: response.data.StoreWhyBuy,
						vehicleReturnGuarantee: !!response.data.VehicleReturnGuarantee,
						dealerClosed: response.data.DealerClosed,
						onlineOrderClosed: response.data.OnlineOrderClosed
					});
					(this as any).$store.commit('setAgent', {
						firstName: response.data.PrimaryAgent.FirstName,
						lastName: response.data.PrimaryAgent.LastName,
						email: response.data.PrimaryAgent.Email,
						phone: response.data.PrimaryAgent.Phone,
						photoUrl: response.data.PrimaryAgent.PhotoUrl
					});
					(this as any).$store.commit('setApp', {
						// showValueAdd: response.data.ValueAdd,
						referenceEnabled: !!response.data.ReferenceEnabled
					});
					if (!response.data.TprEnabled) {
						(this as any).$store.commit('setTpr', {
							tprEnabled: false
						});
					}
					(this as any).$store.commit('setTpr', {
						isTprDown: !!response.data.IsTprDown
					});
					(this as any).$store.commit('setTradeApp', {
						tradeValuationEnabled: !!response.data.TradeInEnabled
					});
				})
					.catch((response) => {
						Helpers.clog(response);
						(this as any).$store.commit('setError', {
							message: `Sorry, your dealer could not be loaded. Please try again or select a different dealer. `
						});
					})
			}
			else {
				(this as any).$store.commit('setError', {
					message: `Sorry, your dealer could not be loaded. Please try again or select a different dealer. `
				});
			}
		},
		commitOpeningHours(data: any): void {
			const hoursList = data.map(function (day: any) {
				const openingArray = day.OpeningTime.split(':');
				const closingArray = day.ClosingTime.split(':');
				if (openingArray[0] > 12) {
					openingArray[0] = parseFloat(openingArray[0]) - 12;
					openingArray[2] = 'pm';
				}
				else {
					openingArray[0] = parseFloat(openingArray[0]);
					openingArray[2] = 'am';
				}
				const opening = openingArray[0] + ':' + openingArray[1] + openingArray[2];
				if (closingArray[0] > 12) {
					closingArray[0] = parseFloat(closingArray[0]) - 12;
					closingArray[2] = 'pm';
				} else {
					closingArray[0] = parseFloat(closingArray[0]);
					closingArray[2] = 'am';
				}
				const closing = closingArray[0] + ':' + closingArray[1] + closingArray[2];
				return { day: day.Day, hours: (day.IsClosed ? 'Closed' : opening + '-' + closing) };
			});
			const todayIndex = hoursList.findIndex((x: any) => x.day === Moment().format('dddd'))
			const hoursListHalf = hoursList.splice(0, todayIndex);
			const finalHoursList = hoursList.concat(hoursListHalf);
			finalHoursList[0].day = 'Today';
			(this as any).$store.commit('setDealer', {
				openingHours: finalHoursList
			});
		},
		commitDateList(closedDays: any): void {
			const dateList = [];
			let i = 0;
			const numDays = 6 + i;
			while (i < numDays) {
				const day = Moment().add(i, 'days');
				const rawDate = Moment(day).format('YYYY-MM-DD');
				const month = Moment(day).format('MMM');
				const date = Moment(day).format('DD');
				const dayName = Moment(day).format('ddd');
				if (!closedDays.includes(Moment(day).format('dddd'))) {
					dateList.push({ rawDate, date, month, dayName, active: false });
				}
				i++;
			}
			(this as any).$store.commit('setDealer', {
				callbackDays: dateList.slice(0, 4)
			});
		},
		getReferenceCodeState(): void {
			const id = (window as any).StoreWebsiteInfo.DealerID;
			const url = Api.getReferenceCodeStateURL(id);
			Helpers.clog(url);
			axios.get(url).then((response: any) => {
				Helpers.clog('has active ref codes:');
				Helpers.clog(response.data);
				(this as any).$store.commit('setApp', { hasActiveReferenceCodes: response.data });
			}).catch((response) => {
				Helpers.clog('Error checking for active ref codes');
				Helpers.clog(response);
			});
		}
	},
	mounted(): void {
		router.onReady(() => {
			if ('RedirectPage' == this.$route.name) return;

			this.setOriginalFinanceType();
			const webkiosk = !!Helpers.getCookie('webkiosk');
			const tprSource: string = this.$route.query.tpr_source ? this.$route.query.tpr_source.toString() : '';
			const guid: string = Helpers.getCookie('tprguid');
			const pegaCaseTracking: string = Helpers.getCookie('tprcaseid');
			const referrer: string = document.referrer || '';
			const slashes: string = -1 == referrer.indexOf("://") ? 'http://' : '';
			const d = this.$route.query.d || this.$route.query.di;

			(this as any).$store.commit('setDisclaimers', disclaimerData.disclaimers);
			(this as any).$store.commit('setApp', {
				financeDeposit: (window as any).StoreWebsiteInfo.DepositAmount || 100,
				webkiosk: webkiosk,
				tprSource: tprSource && !isNaN(parseInt(tprSource)) ? tprSource : null,
				referrer: referrer ? (slashes + referrer) : ''
			});

			if (guid || pegaCaseTracking || d) {
				// the product this case was last saved with, if this browser saved it
				this.savedQuoteLoanType = Helpers.getTprLoanTypeCookie(pegaCaseTracking);
				(this as any).$store.commit('setQuoteCreate', {
					...this.quoteCreate,
					guestRateIdentifier: guid || '',
					pegaCaseTracking: pegaCaseTracking || '',
				});
				(this as any).$store.commit('setTpr', {
					detailIdentifier: d || '',
					hasLoadedWithTpr: !!guid
				});
				// hydrate the quote slice on return visits so the Entanglement
				// lifecycle (updateQuote/retrieve/lastSaved) can address the case
				if (guid || pegaCaseTracking) {
					(this as any).$store.commit('setQuoteCreate', {
						guestRateIdentifier: guid || '',
						pegaCaseTracking: pegaCaseTracking || ''
					});
				}
			}

			const enquirySources = Helpers.getEnquirySources();
			const utmSource: any = this.$route.query.utm_source || '';
			const enqSource: any = this.$route.query.enquiry_source || '';
			const source1: string = enquirySources[utmSource];
			const source2: string = enquirySources[enqSource];
			if ((utmSource || enqSource) && !(source1 || source2)) {
				this.getEnquirySources(utmSource || enqSource);
			}
			else {
				const sourceId = source1 || source2 || 1;
				(this as any).$store.commit('setApp', {
					enquirySource: {
						id: sourceId,
						suburb: '',
						value: utmSource || enqSource
					}
				});
				this.setEnquirySourceCookie(source1 || source2 || '');
			}

			this.getReferenceCodeState();
			this.getUserInfo();
			this.getDealer();
		});
	}
});
